import React from 'react';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import variables from '../../variables';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import { Button, Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import {
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../styled-components';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../lib/helpers/generateMonthOptions';
import SearchInput from '../../commons/SearchInput';
import { useTranslation } from 'react-i18next';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import RecurringFeesTable from './RecurringFeesTable';
import ContractsImportPaidsFeedbackModal from './ContractsImportPaidsFeedbackModal';
import ContractsImportPaidsFeedbackModalPolis from './ContractsImportPaidsFeedbackModalPolis';
import ExportCSVButton from './ExportCSVButton';

const RecurringFeesPresentational = ({
  profile,
  data,
  formattedData,
  query,
  total,
  totPod,
  totPdr,
  onFilter,
  onStatusChanged,
  handleFileListView,
  handleDelete,
  onImportContractPaids,
  onImportContractPaidsPolis,
  contractsImportFeedbackData,
  contractsImportFeedbackDataPolis,
  hasImportedContracts,
  hasImportedContractsPolis,
  toggleShowImportFeedback,
  toggleShowImportFeedbackPolis,
  onAddPayment,
}) => {
  const [t] = useTranslation('CONTRACTS');
  const { offset, limit } = query;

  function handleImportFile(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportContractPaids(data);
    }
  }

  function handleImportFilePolis(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportContractPaidsPolis(data);
    }
  }

  return (
    <div className="App">
      <ContractsImportPaidsFeedbackModal
        data={contractsImportFeedbackData}
        toggle={toggleShowImportFeedback}
        isOpen={hasImportedContracts}
      />

      <ContractsImportPaidsFeedbackModalPolis
        data={contractsImportFeedbackDataPolis}
        toggle={toggleShowImportFeedbackPolis}
        isOpen={hasImportedContractsPolis}
      />

      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:RECURRING_FEES')}
            icon={
              <IconBuilding fill={variables.white} style={{ height: '25px' }} />
            }
          />

          {profile === 'EON_ENERGY' && (
            <Row className="align-items-center">
              <Col className="">
                <ContFlexRight>
                  Contratti POD:&nbsp;<strong>{totPod}</strong>&nbsp; |
                  Contratti PDR:&nbsp;<strong>{totPdr}</strong>
                </ContFlexRight>
              </Col>
            </Row>
          )}

          {profile.polis === true && (
            <Row>
              <Col sm="0" md="0" lg="9" xl="9"></Col>
              <Col sm="12" md="12" lg="3" xl="3">
                <ExportCSVButton data={formattedData} />
              </Col>
            </Row>
          )}

          {profile.polis !== true && profile.type === 'EON_ENERGY' && (
            <Row>
              <Col sm="12" md="12" lg="4" xl="4">
                <Button
                  href={`/examples/Template_Contratti_Ricorrenti_Incassi.csv`}
                  target="_blank"
                  color="primary"
                  style={{ width: '100%' }}
                >
                  Scarica template importazione
                </Button>
              </Col>
              <Col sm="12" md="12" lg="4" xl="4">
                <Button
                  href={`/documentation/Extra_Importazione_contratti_ricorrenti_incassi.pdf`}
                  target="_blank"
                  color="primary"
                  style={{ width: '100%' }}
                >
                  Scarica documentazione importazione
                </Button>
              </Col>
            </Row>
          )}

          <Row className="search-add-cont m-t-20" style={{ rowGap: '20px' }}>
            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_DATE_FEE_YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectdateFeeYear"
                        name="dateFeeYear"
                        value={query && query.dateFeeYear}
                        onChange={({ target: { value: dateFeeYear } }) => {
                          onFilter({ dateFeeYear });
                        }}
                      >
                        {generateYearOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_DATE_FEE_MONTH')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="dateFeeMonth"
                        name="dateFeeMonth"
                        disabled={!query.dateFeeYear}
                        value={query && query.dateFeeMonth}
                        onChange={({ target: { value: dateFeeMonth } }) =>
                          onFilter({ dateFeeMonth })
                        }
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>Stato incasso</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="paid"
                        name="paid"
                        onChange={({ target: { value: paid } }) =>
                          onFilter({ paid })
                        }
                        value={query.paid || ''}
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="PAID">Pagato</option>
                        <option value="NOT_PAID">Non pagato</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Tipo contratto</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="contractType"
                        name="contractType"
                        value={query.contractType}
                        onChange={({ target: { value: contractType } }) =>
                          onFilter({ contractType })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="POD">POD</option>
                        <option value="PDR">PDR</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            {profile.type === 'EON_ENERGY' && (
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.admin }}
                  onFilter={({ search }) => onFilter({ admin: search })}
                  label={t('SEARCH:ADMINISTRATOR')}
                />
              </Col>
            )}

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.supplier }}
                onFilter={({ search }) => onFilter({ supplier: search })}
                label={t('SEARCH:BY_SUPPLIER')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.customer }}
                onFilter={({ search }) => onFilter({ customer: search })}
                label={t('SEARCH:CUSTOMER')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.pod_pdr }}
                onFilter={({ search }) => onFilter({ pod_pdr: search })}
                label={t('SEARCH:POD_PDR')}
              />
            </Col>

            {profile.polis !== true && profile.type === 'EON_ENERGY' && (
              <Col sm="12" md="6" lg="3" xl="3">
                <FormGroup>
                  <CustomInput
                    type="file"
                    id="importFilee"
                    name="importFilee"
                    onChange={(event) => handleImportFile(event)}
                    accept=".csv"
                  />
                  <Label for="selectFile">
                    {t('ENERGY_CONTRACT:CHOOSE_FILE')}
                    &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                </FormGroup>
              </Col>
            )}

            {profile.polis === true && profile.type === 'EON_ENERGY' && (
              <Col sm="12" md="6" lg="3" xl="3">
                <FormGroup>
                  <CustomInput
                    type="file"
                    id="importFilePolis"
                    name="importFilePolis"
                    onChange={(event) => handleImportFilePolis(event)}
                    accept=".xlsx,.xls"
                  />
                  <Label for="importFilePolis">
                    {t('ENERGY_CONTRACT:CHOOSE_FILE_POLIS')}
                    &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                </FormGroup>
              </Col>
            )}
          </Row>
        </section>

        <section className="m-t-20">
          <RecurringFeesTable
            profile={profile}
            profileType={profile.type}
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            handleFileListView={handleFileListView}
            handleDelete={handleDelete}
            onStatusChanged={onStatusChanged}
            onAddPayment={onAddPayment}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
      </div>
    </div>
  );
};

export default RecurringFeesPresentational;
